import { LogoSize } from '@/shared/types/types';

/** Ancho y alto en px del SVG del logo (viewBox 40×40). */
export const logoSizePxMap: Record<LogoSize, number> = {
  sm: 24,
  md: 32,
  lg: 40,
};
